export default Object.freeze({
  OpenAI: 1,
});
